"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUser = void 0;

var _http = require("js-utils/http");

var getUserUrl = function getUserUrl() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'me';
  return "/api/v3/users/".concat(id, "/");
};

var getUser = function getUser(id) {
  return (0, _http.sdkRequest)(getUserUrl(id));
};

exports.getUser = getUser;
//# sourceMappingURL=user.js.map